export default __webpack_public_path__ + "static/corner-6d62d8fc929c973d0490bcb0dbd7e1dc.png";